<template>
  <v-layout row fill-height justify-center align-center id="sign-in-container">
    <v-flex xs8 id="sign-in-img-container" style="background-color: rgb(234, 235, 237);">
      <v-img class="logo" :src="require('@/assets/logo_samll.jpg')">
        <div id="signInImgOverlay"></div>
      </v-img>
      <div class="slogan">Less Time Typing More Time Caring<br>醫護好朋友 診療好輕鬆</div>
      <div class="copyright">© KenKone Co., Ltd. 2019 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Service: service@kenkone.com</div>
    </v-flex>
    <v-flex xs6>
      <v-layout justify-center align-center>
        <v-flex xs6 class="text-xs-center">
          <div class="headline font-weight-light mb-4"><font style="font-family: DFKai-sb;">醫瓦士-內視鏡語音助理系統</font><br><font class="version">EVAS-01<br>v1.0.0</font></div>
          <v-form v-model="isSignInFormValid" @submit.prevent="userSignIn({username,password})">
            <v-text-field 
              v-model="username" 
              label="Username"
              :rules="[v => !!v || 'Username cannot be empty']"
              class="mt-2 mb-3"
            ></v-text-field>
            <v-text-field 
              v-model="password" 
              label="Password" 
              type="password"
              :rules="[v => !!v || 'Password cannot be empty']"
              class="mb-2 mt-3"
            >
            </v-text-field>
            <v-text-field
              label= "Verification code "
              :rules="[v => v == identifyCode || 'Verification code error, please re-enter']"
            >
            </v-text-field>
            <div class="get-code" @clcik="refreshCode()">
              <s-identify :identifyCode="identifyCode"></s-identify>
            </div>            
            <v-alert
              :value="showErrorAlert"
              type="error"
              outline
            >
              Username / Password don't match. Please try again.
            </v-alert>
            <v-btn 
              type="submit"
              color="blue darken-2" 
              :disabled="!isSignInFormValid" 
              dark
              class="mt-4"
              
            >
              Sign In
            </v-btn>
          </v-form>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import SIdentify from "../components/Identify.vue"; 

  export default {

    components: {
      SIdentify 
    },

    name: 'SignIn',
    created () {
       window.onkeydown = function(e) {};
       window.onkeyup = function(e) {};
    },

    data () {
      return {
        username: null,
        password: null,
        isSignInFormValid: true,
        identifyCode: "",
        identifyCodes: "0123456789",          
      }
    },

    computed: {
      ...mapGetters([
        'getError'
      ]),

      showErrorAlert () {
        return this.getError === 'auth'
      }
    },

    mounted () {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },    

    methods: {
      ...mapActions([
        'userSignIn'
      ]),
      refreshCode () {//
        this.identifyCode = "";
        this.makeCode(this.identifyCodes,4);
      },
      randomNum (min, max) {
        max = max + 1
        return Math.floor(Math.random() * (max - min) + min)
      },
      // 隨機生成驗證碼字符串
      makeCode (data, len) {
        for (let i = 0; i < len; i++) {
        this.identifyCode += data[this.randomNum(0, data.length - 1)]
      }
    }      
  }
}
</script>

<style lang="scss">
  @import '@/styles/pages/page_signIn.scss'
</style>